import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type EventVenueAirportQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  withSuggestion?: Types.Scalars['Boolean'];
}>;

export type EventVenueAirportQuery = {
  __typename?: 'Query';
  event?: {
    __typename?: 'Event';
    id: string;
    travelSettings?: {
      __typename?: 'TravelSettings';
      venueAirport?: { __typename?: 'VenueAirport'; googlePlaceId: string; name: string; formattedAddress: string; latitude: number; longitude: number } | null;
    } | null;
    suggestedVenueAirport?: { __typename?: 'VenueAirport'; googlePlaceId: string; name: string; formattedAddress: string; latitude: number; longitude: number } | null;
  } | null;
};

export const EventVenueAirportDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EventVenueAirport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withSuggestion' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'event' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'travelSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'venueAirport' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'formattedAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'suggestedVenueAirport' },
                  directives: [
                    {
                      kind: 'Directive',
                      name: { kind: 'Name', value: 'include' },
                      arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'withSuggestion' } } }],
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'googlePlaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formattedAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEventVenueAirportQuery__
 *
 * To run a query within a React component, call `useEventVenueAirportQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventVenueAirportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventVenueAirportQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      withSuggestion: // value for 'withSuggestion'
 *   },
 * });
 */
export function useEventVenueAirportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventVenueAirportQuery, EventVenueAirportQueryVariables>) {
  return ApolloReactHooks.useQuery<EventVenueAirportQuery, EventVenueAirportQueryVariables>(EventVenueAirportDocument, baseOptions);
}
export function useEventVenueAirportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventVenueAirportQuery, EventVenueAirportQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<EventVenueAirportQuery, EventVenueAirportQueryVariables>(EventVenueAirportDocument, baseOptions);
}
export type EventVenueAirportQueryHookResult = ReturnType<typeof useEventVenueAirportQuery>;
export type EventVenueAirportLazyQueryHookResult = ReturnType<typeof useEventVenueAirportLazyQuery>;
export type EventVenueAirportQueryResult = Apollo.QueryResult<EventVenueAirportQuery, EventVenueAirportQueryVariables>;
